"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _recompose = require("recompose");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectWrap = function selectWrap(isSelecting) {
  return (0, _glamor.css)({
    position: "relative",
    display: "inline-block",
    minWidth: (0, _css.unitRem)(8),
    outline: "none",
    zIndex: isSelecting ? 3 : 0

    // ':focus': {
    //   '& div': {
    //     ...!isSelecting && {
    //       border: `2px solid ${colors.alternateBlue}`,
    //     },
    //   },
    // },
  });
};

var wrap = function wrap(thin, disabled, IndiePopup) {
  return (0, _glamor.css)({
    display: "block",
    position: "relative",
    minHeight: IndiePopup ? "3rem" : (0, _css.unitRem)(thin ? 1.5 : 2),
    cursor: disabled ? "not-allowed" : "pointer",
    border: "2px solid transparent",
    outline: "none",
    marginTop: "-2px",

    zIndex: 0,

    // ':focus': {
    //   border: `2px solid ${colors.alternateBlue}`,
    // },
    transition: "border " + _css.time.fast
  });
};

var fake = function fake(isSelecting, thin, IndiePopup, error) {
  return (0, _glamor.css)(_css.cover, {
    display: "block",
    borderRadius: "0",
    WebkitAppearance: "none",
    position: "relative",
    textAlign: IndiePopup && "left",
    width: "100%",
    height: IndiePopup ? "3rem" : (0, _css.unitRem)(thin ? 1.5 : 2),

    zIndex: isSelecting ? 3 : 1,

    font: "inherit",
    fontSize: IndiePopup ? (0, _css.unitRem)(0.75) : (0, _css.unitRem)(thin ? 0.625 : 0.75),
    padding: "0 " + (0, _css.unitRem)(0.5),

    color: "#fff",
    border: "2px solid " + (error ? _css.colors.red : "transparent"),
    background: _css.colors.medDarkGray,

    "&:focus": {
      outline: "none"
    },
    cursor: "inherit"
  });
};

var fakeName = (0, _glamor.css)(_css.vCenter, {
  display: "block"
});

var fakeDownArrow = (0, _glamor.css)(_css.vCenter, {
  zIndex: 100,
  display: "block",
  right: (0, _css.unitRem)(0.75),

  border: (0, _css.unitRem)(0.25) + " solid transparent",
  borderBottom: "none",
  borderTopColor: _css.colors.gray
});

var fakeUpArrow = (0, _glamor.css)(_css.vCenter, {
  display: "block",
  right: (0, _css.unitRem)(0.75),
  zIndex: 100,

  border: (0, _css.unitRem)(0.25) + " solid transparent",
  borderTop: "none",
  borderBottomColor: _css.colors.gray
});

var placeholder = (0, _glamor.css)(_css.vCenter, {
  zIndex: 100,
  textAlign: "left",
  display: "block",
  left: (0, _css.unitRem)(0.75),
  color: _css.colors.gray
});

var label = function label(thin) {
  return (0, _glamor.css)({
    display: "block",
    textAlign: "left",

    color: _css.colors.gray,
    textTransform: "uppercase",

    fontSize: (0, _css.unitRem)(thin ? 0.625 : 0.75),
    fontWeight: 700,

    marginBottom: (0, _css.unitRem)(0.25)
  });
};

var dropdownCss = function dropdownCss(thin, isSelecting, IndiePopup) {
  return (0, _glamor.css)(_css.noListStyle, _css.dropShadow, (0, _extends3.default)({}, !isSelecting && {
    display: "none"
  }, {
    position: "absolute",
    top: IndiePopup ? "2.3rem" : (0, _css.unitRem)(thin ? 1.5 : 2),
    height: "auto",
    maxHeight: thin ? (0, _css.unitRem)(13.25) : (0, _css.unitRem)(13.75),

    width: "100%",
    zIndex: 2,

    background: _css.colors.medDarkGray,
    borderTop: "none"
  }));
};

var itemStyle = (0, _glamor.css)({
  lineHeight: 1
});

var scrollableRegion = (0, _glamor.css)({
  height: "auto",
  maxHeight: (0, _css.unitRem)(9),
  overflowY: "auto",
  "& ::-webkit-scrollbar": {
    overflow: "visible",
    width: 16,
    color: "black"
  }
});

var optionCss = function optionCss(fakeElement) {
  var focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isSelectedItem = arguments[2];
  var thin = arguments[3];
  return (0, _glamor.css)(_css.btnReset, {
    width: "100%",
    fontSize: (0, _css.unitRem)(thin ? 0.625 : 0.75),

    padding: (0, _css.unitRem)(0.6) + " " + (0, _css.unitRem)(0.75),
    paddingLeft: !fakeElement ? (0, _css.unitRem)(1.75) : (0, _css.unitRem)(0.75),
    margin: 0,

    color: isSelectedItem ? _css.colors.white : _css.colors.gray,

    background: focus ? "#2C2C2C" : _css.colors.medDarkGray,

    ":active": {
      background: _css.colors.medDarkGray2
    }
  });
};

var checkmarkBox = (0, _glamor.css)({
  position: "absolute",
  left: (0, _css.unitRem)(0.05),

  display: "inline-block",
  width: (0, _css.unitRem)(1.8),
  height: (0, _css.unitRem)(1.15)
});

var checkmark = (0, _glamor.css)({
  display: "block",
  content: "",
  opacity: 1,

  width: 14,
  height: 7,

  margin: "0 auto",
  lineHeight: "35%",
  verticalAlign: "middle",
  marginTop: "8%",

  border: "3px solid " + _css.colors.white,
  borderTop: "none",
  borderRight: "none",

  transform: "rotate(-45deg)",
  transition: "transform " + _css.time.fast + ", opacity " + _css.time.fast
});

var error = (0, _glamor.css)({
  display: "block",
  marginTop: (0, _css.unitRem)(0.75),
  color: _css.colors.red,

  fontWeight: 400
});

var getValueName = function getValueName(options, value) {
  if (value !== "") {
    return _ramda2.default.compose(_ramda2.default.propOr("", "name"), _ramda2.default.find(_ramda2.default.propEq("value", value)))(options);
  }

  if (options.length > 0) {
    return options[0].name;
  }
  return "";
};

var getIndexOfSelectedItem = function getIndexOfSelectedItem(options, value) {
  if (value !== "") {
    return _ramda2.default.compose(_ramda2.default.findIndex(_ramda2.default.propEq("value", value)))(options);
  }
  return 0;
};

var Select = function Select(props) {
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _react2.default.createElement(
      "div",
      {
        tabIndex: 0,
        role: "button",
        onClick: props.handleSelecting,
        className:
        // eslint-disable-next-line react/prop-types
        (0, _glamor.css)(selectWrap(props.isSelecting), props.className),
        onKeyDown:
        // eslint-disable-next-line react/prop-types
        props.handleComponentInputKeyDown
      },
      props.label ?
      // eslint-disable-next-line jsx-a11y/label-has-for
      _react2.default.createElement(
        "label",
        null,
        _react2.default.createElement(
          "span",
          { className: label(props.thin || props.thinLabel) },
          props.label
        )
      ) : null,

      // eslint-disable-next-line react/prop-types
      _react2.default.createElement(
        "div",
        { className: wrap(props.thin, props.disabled, props.IndiePopup) },
        props.placeholder ? _react2.default.createElement(
          "div",
          null,
          !props.dirty && _react2.default.createElement(
            "span",
            {
              className:
              // eslint-disable-next-line react/prop-types
              placeholder
            },
            props.placeholder
          ),
          _react2.default.createElement("span", {
            className:
            // eslint-disable-next-line react/prop-types
            props.isSelecting ? fakeUpArrow : fakeDownArrow
          }),
          _react2.default.createElement("input", {
            placeholder: props.placeholder,
            type: "button",
            value: props.dirty ? getValueName(props.options, props.value) : "",
            tabIndex: -1,
            onClick:
            // eslint-disable-next-line react/prop-types
            props.handleSelecting,
            onKeyDown:
            // eslint-disable-next-line react/prop-types
            props.handleInputKeyDown,
            className: (0, _glamor.css)(
            // eslint-disable-next-line react/prop-types
            fake(props.isSelecting, props.thin, props.IndiePopup, !props.active && props.touched && props.error && !props.simpleError), props.headerClassName)
          })
        ) : _react2.default.createElement(
          "button",
          {
            tabIndex: -1,
            onClick:
            // eslint-disable-next-line react/prop-types
            props.handleSelecting,
            onKeyDown:
            // eslint-disable-next-line react/prop-types
            props.handleInputKeyDown,
            className: (0, _glamor.css)(
            // eslint-disable-next-line react/prop-types
            fake(props.isSelecting, props.thin, true, props.error), props.headerClassName),
            type: "button"
          },
          _react2.default.createElement(
            "span",
            { className: fakeName },
            getValueName(props.options, props.value)
          ),
          _react2.default.createElement("span", {
            className:
            // eslint-disable-next-line react/prop-types
            props.isSelecting ? fakeUpArrow : fakeDownArrow
          })
        ),

        // eslint-disable-next-line react/prop-types
        _react2.default.createElement(
          "ul",
          {
            className: (0, _glamor.css)(dropdownCss(props.thin, props.isSelecting, props.IndiePopup), scrollableRegion)
          },
          props.options.map(function (option, i) {
            return _react2.default.createElement(
              "li",
              { key: option.value, className: itemStyle },
              _react2.default.createElement(
                "button",
                {
                  className: optionCss(false, props.focusedItem === i, props.selectedItem === i, props.thin),
                  tabIndex: i,
                  onMouseEnter: function onMouseEnter() {
                    return props.handleMouseOver(i);
                  },
                  onClick: props.handleItemClick,
                  type: "button"
                },

                // eslint-disable-next-line react/prop-types
                props.selectedItem === i ? _react2.default.createElement(
                  "span",
                  { className: checkmarkBox },
                  _react2.default.createElement("span", { className: checkmark }),
                  " "
                ) : null,
                option.name
              )
            );
          })
        )
      ),
      !props.active && props.touched && props.error && !props.simpleError && _react2.default.createElement(
        "span",
        { className: error },
        props.error
      )
    )
  );
};

var UP_ARROW = 38;
var DOWN_ARROW = 40;
var ESCAPE = 27;
var RETURN = 13;

var catchKeys = [UP_ARROW, DOWN_ARROW, ESCAPE, RETURN];

var containsFlipped = _ramda2.default.flip(_ramda2.default.contains);

exports.default = (0, _recompose.compose)((0, _recompose.withState)("isSelecting", "setIsSelecting", false), (0, _recompose.withState)("selectedItem", "setSelectedItem", 0), (0, _recompose.withState)("focusedItemText", "setFocusedItemText", ""), (0, _recompose.withState)("focusedItem", "setFocusedItem", 0), (0, _recompose.withState)("timer", "setTimer", null), (0, _recompose.withHandlers)({
  handleSelecting: function handleSelecting(_ref) {
    var disabled = _ref.disabled,
        isSelecting = _ref.isSelecting,
        setIsSelecting = _ref.setIsSelecting;
    return function (ev) {
      ev.preventDefault();
      setIsSelecting(disabled ? false : !isSelecting);
    };
  },
  handleWindowClick: function handleWindowClick(_ref2) {
    var setFocusedItemText = _ref2.setFocusedItemText,
        setIsSelecting = _ref2.setIsSelecting;
    return function () {
      setFocusedItemText("");
      setIsSelecting(false);
    };
  },
  handleInputArrowKeyDown: function handleInputArrowKeyDown(_ref3) {
    var options = _ref3.options,
        focusedItem = _ref3.focusedItem,
        setFocusedItem = _ref3.setFocusedItem;
    return function (ev, keyCode) {
      var index = 0;
      var child = ev;
      var nextItemToGainFocus = focusedItem;
      if (focusedItem > 0 && focusedItem < options.length - 1) {
        nextItemToGainFocus = keyCode === UP_ARROW ? focusedItem - 1 : focusedItem + 1;
      }

      if (nextItemToGainFocus > 0) {
        while (index !== nextItemToGainFocus) {
          child = child.nextSibling;
          index += 1;
        }
      }

      var childBottom = child.getBoundingClientRect().bottom;
      var childHeight = child.getBoundingClientRect().height;
      var parentBottom = child.parentNode.getBoundingClientRect().bottom;
      var parentTop = child.parentNode.getBoundingClientRect().top;
      if (childBottom > parentBottom) {
        child.parentNode.scrollTop += childHeight;
      } else if (childBottom - childHeight / 2 <= parentTop) {
        child.parentNode.scrollTop -= childHeight;
      }

      return _ramda2.default.compose(_ramda2.default.T, _ramda2.default.compose(setFocusedItem, _ramda2.default.clamp(0, _ramda2.default.dec(options.length)), _ramda2.default.add(focusedItem), _ramda2.default.cond([[_ramda2.default.equals(UP_ARROW), _ramda2.default.always(-1)], [_ramda2.default.equals(DOWN_ARROW), _ramda2.default.always(1)], [_ramda2.default.T, _ramda2.default.always(0)]])));
    };
  },
  handleInputEscapeKeyDown: function handleInputEscapeKeyDown(_ref4) {
    var setFocusedItemText = _ref4.setFocusedItemText,
        setIsSelecting = _ref4.setIsSelecting;
    return function () {
      setFocusedItemText("");
      setIsSelecting(false);
    };
  },
  handleMouseOver: function handleMouseOver(_ref5) {
    var setFocusedItem = _ref5.setFocusedItem;
    return function (item) {
      return setFocusedItem(item);
    };
  },
  handleReturnKeyDown: function handleReturnKeyDown(_ref6) {
    var setFocusedItemText = _ref6.setFocusedItemText,
        onChange = _ref6.onChange,
        options = _ref6.options,
        setIsSelecting = _ref6.setIsSelecting,
        focusedItem = _ref6.focusedItem,
        setSelectedItem = _ref6.setSelectedItem;
    return function () {
      var event = {
        stopPropagation: _ramda2.default.identity,
        preventDefault: _ramda2.default.identity,
        type: "change",
        target: {
          type: "select-one",
          value: options[focusedItem].value
        }
      };
      setSelectedItem(focusedItem);

      onChange(event);
      setFocusedItemText("");
      setIsSelecting(false);
      return true;
    };
  },
  handleMiscKeyPress: function handleMiscKeyPress(_ref7) {
    var focusedItemText = _ref7.focusedItemText,
        setFocusedItemText = _ref7.setFocusedItemText,
        setFocusedItem = _ref7.setFocusedItem,
        options = _ref7.options,
        setTimer = _ref7.setTimer,
        timer = _ref7.timer;
    return function (firstOption, keyCode) {
      var newFocusedItemText = focusedItemText + String.fromCharCode(keyCode);
      setFocusedItemText(newFocusedItemText);
      var index = void 0;
      var elm = firstOption;
      for (index = 0; index < options.length - 1; index += 1) {
        if (_ramda2.default.startsWith(_ramda2.default.toLower(newFocusedItemText), _ramda2.default.toLower(options[index].name))) {
          break;
        }
      }

      if (timer !== null) {
        clearTimeout(timer);
      }

      setTimer(setTimeout(function () {
        setFocusedItemText("");
      }, 500));

      if (index < options.length) {
        setFocusedItem(index);
        if (index === 0) {
          // This didn't work, so moved scrolling into timeout
          // elm.parentNode.scrollTop = 0
          // eslint-disable-next-line no-return-assign
          setTimeout(function () {
            return elm.parentNode.scrollTop = 0;
          }, 0);
        } else {
          // eslint-disable-next-line no-return-assign
          setTimeout(function () {
            return elm.parentNode.scrollTop = index * elm.getBoundingClientRect().height;
          }, 0);
        }
      } else {
        // scroll to bottom if no match found
        // eslint-disable-next-line no-return-assign
        setTimeout(function () {
          return elm.parentNode.scrollTop = (options.length - 1) * elm.getBoundingClientRect().height;
        }, 0);
      }
    };
  },
  handleItemClick: function handleItemClick(_ref8) {
    var setFocusedItemText = _ref8.setFocusedItemText,
        onChange = _ref8.onChange,
        options = _ref8.options,
        setIsSelecting = _ref8.setIsSelecting,
        focusedItem = _ref8.focusedItem,
        setSelectedItem = _ref8.setSelectedItem;
    return function (ev) {
      var event = {
        stopPropagation: _ramda2.default.identity,
        preventDefault: _ramda2.default.identity,
        type: "change",
        target: {
          type: "select-one",
          value: options[focusedItem].value
        }
      };
      setSelectedItem(focusedItem);

      ev.preventDefault();
      onChange(event);
      setFocusedItemText("");
      setIsSelecting(false);
    };
  }
}), (0, _recompose.withHandlers)({
  handleInputKeyDown: function handleInputKeyDown(_ref9) {
    var handleMiscKeyPress = _ref9.handleMiscKeyPress,
        handleInputArrowKeyDown = _ref9.handleInputArrowKeyDown,
        handleInputEscapeKeyDown = _ref9.handleInputEscapeKeyDown,
        handleReturnKeyDown = _ref9.handleReturnKeyDown;
    return function (ev) {
      var firstOption = ev.target.nextSibling.firstChild;
      var keyCode = _ramda2.default.prop("keyCode")(ev);

      if (keyCode > 47 && keyCode < 58 || keyCode === 32 || keyCode > 64 && keyCode < 91 || keyCode > 95 && keyCode < 112) {
        ev.preventDefault();
        handleMiscKeyPress(firstOption, keyCode);
      }

      return _ramda2.default.both(_ramda2.default.compose(containsFlipped(catchKeys), _ramda2.default.prop("keyCode")), _ramda2.default.both(_ramda2.default.compose(_ramda2.default.cond([[containsFlipped([UP_ARROW, DOWN_ARROW]), handleInputArrowKeyDown(firstOption, keyCode)], [_ramda2.default.equals(RETURN), handleReturnKeyDown], [_ramda2.default.equals(ESCAPE), handleInputEscapeKeyDown]]), _ramda2.default.prop("keyCode")), _ramda2.default.call(_ramda2.default.invoker(0, "preventDefault"))))(ev);
    };
  },
  handleComponentInputKeyDown: function handleComponentInputKeyDown(_ref10) {
    var disabled = _ref10.disabled,
        setIsSelecting = _ref10.setIsSelecting,
        isSelecting = _ref10.isSelecting;
    return function (ev) {
      if (!disabled && !isSelecting) {
        var buttons = ev.target.getElementsByTagName("button");
        if (buttons && buttons.length > 0) {
          ev.preventDefault();
          buttons[0].focus();
          var keyCode = _ramda2.default.prop("keyCode")(ev);
          if (containsFlipped([32, DOWN_ARROW, UP_ARROW, RETURN])(keyCode)) {
            setIsSelecting(!isSelecting);
          }
        }
      }
    };
  }
}), (0, _recompose.lifecycle)({
  componentWillMount: function componentWillMount() {
    var selectedItemIndex = getIndexOfSelectedItem(this.props.options, this.props.value);
    this.props.setSelectedItem(selectedItemIndex);
    this.props.setFocusedItem(selectedItemIndex);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _this = this;

    if (this.props.value !== nextProps.value) {
      var index = nextProps.options.findIndex(function (option) {
        return option.value === nextProps.value;
      });

      if (index === -1) {
        this.props.setSelectedItem(0);
      } else {
        this.props.setSelectedItem(_ramda2.default.clamp(0, _ramda2.default.dec(nextProps.options.length), index));
      }
    }
    if (!this.props.isSelecting && nextProps.isSelecting) {
      // eslint-disable-next-line no-undef
      setTimeout(function () {
        return window.addEventListener("click", _this.props.handleWindowClick);
      }, 0);
    } else if (this.props.isSelecting && !nextProps.isSelecting) {
      // eslint-disable-next-line no-undef
      window.removeEventListener("click", this.props.handleWindowClick);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    // eslint-disable-next-line no-undef
    window.removeEventListener("click", this.props.handleWindowClick);
  }
}), (0, _recompose.shouldUpdate)(function (props, nextProps) {
  return !_ramda2.default.equals(props, nextProps);
}))(Select);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Select/Select.jsx
// module id = 1237
// module chunks = 0